import React, { useState } from 'react';
import { Button, Nav, NavItem, NavLink } from 'reactstrap';
import TechnicalSupportChat from '../components/TechnicalSupportChat';
import { getCurrentLanguage } from '../ai/technicalSupportDecisionTree';

const TechnicalSupportChatView = () => {
  const [chats, setChats] = useState([{ id: 1, title: 'Chat 1' }]);
  const [activeChat, setActiveChat] = useState(1);
  const [nextChatId, setNextChatId] = useState(2);

  const addNewChat = () => {
    const newChat = { id: nextChatId, title: `Chat ${nextChatId}` };
    setChats([...chats, newChat]);
    setActiveChat(nextChatId);
    setNextChatId(nextChatId + 1);
  };

  const closeChat = (chatId) => {
    const updatedChats = chats.filter(chat => chat.id !== chatId);
    if (updatedChats.length === 0) {
      window.history.back();
    } else {
      setChats(updatedChats);
      if (activeChat === chatId) {
        setActiveChat(updatedChats[0].id);
      }
    }
  };

  const currentLang = getCurrentLanguage();
  const labels = {
    es: { newChat: 'Nuevo Chat', technicalSupport: 'Soporte Técnico' },
    en: { newChat: 'New Chat', technicalSupport: 'Technical Support' },
    fr: { newChat: 'Nouveau Chat', technicalSupport: 'Support Technique' },
    de: { newChat: 'Neuer Chat', technicalSupport: 'Technischer Support' },
    it: { newChat: 'Nuova Chat', technicalSupport: 'Supporto Tecnico' },
    pt: { newChat: 'Novo Chat', technicalSupport: 'Suporte Técnico' }
  };
  const uiLabels = labels[currentLang] || labels['es'];

  return (
    <div style={{ 
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#f8f9fa',
      overflow: 'hidden'
    }}>
      {/* Fixed Header with Tabs */}
      <div style={{
        backgroundColor: '#ffffff',
        borderBottom: '2px solid #e9ecef',
        flexShrink: 0,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
      }}>
        <div style={{ 
          padding: '1rem 1.5rem',
          background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '1.5rem'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', minWidth: 0 }}>
            <i className="fa fa-headphones" style={{ fontSize: '1.5rem', flexShrink: 0 }}></i>
            <div style={{ minWidth: 0 }}>
              <h4 style={{ margin: 0, fontWeight: 600, fontSize: '1.25rem', whiteSpace: 'nowrap' }}>
                {uiLabels.technicalSupport}
              </h4>
              <small style={{ opacity: 0.9, fontSize: '0.85rem', display: 'block', whiteSpace: 'nowrap' }}>Asistente de diagnóstico automático</small>
            </div>
          </div>
          
          {/* Tabs inline with header */}
          <div style={{ 
            display: 'flex',
            gap: '0.5rem',
            overflowX: 'auto',
            flex: 1,
            alignItems: 'center',
            minWidth: 0
          }}>
            {chats.map(chat => (
              <div
                key={chat.id}
                onClick={() => setActiveChat(chat.id)}
                style={{
                  cursor: 'pointer',
                  padding: '0.5rem 1rem',
                  backgroundColor: activeChat === chat.id ? 'rgba(255,255,255,0.95)' : 'rgba(255,255,255,0.15)',
                  color: activeChat === chat.id ? '#007bff' : 'white',
                  borderRadius: '0.375rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  fontWeight: activeChat === chat.id ? 600 : 500,
                  fontSize: '0.9rem',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap',
                  flexShrink: 0,
                  border: activeChat === chat.id ? '2px solid rgba(255,255,255,0.3)' : '2px solid transparent'
                }}
              >
                <i className="fa fa-comments" style={{ fontSize: '0.85rem' }}></i>
                <span>{chat.title}</span>
                {chats.length > 1 && (
                  <i 
                    className="fa fa-times-circle"
                    onClick={(e) => {
                      e.stopPropagation();
                      closeChat(chat.id);
                    }}
                    style={{ 
                      cursor: 'pointer',
                      opacity: 0.7,
                      fontSize: '0.9rem',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.opacity = '1'}
                    onMouseLeave={(e) => e.target.style.opacity = '0.7'}
                  />
                )}
              </div>
            ))}
          </div>

          <Button 
            color="light"
            size="sm"
            onClick={addNewChat}
            style={{
              fontWeight: 600,
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              border: 'none',
              flexShrink: 0,
              whiteSpace: 'nowrap'
            }}
          >
            <i className="fa fa-plus mr-2"></i>
            {uiLabels.newChat}
          </Button>
        </div>
      </div>

      {/* Chat Content Area */}
      <div style={{ flex: 1, overflow: 'hidden', backgroundColor: '#f8f9fa', display: 'flex', flexDirection: 'column' }}>
        {chats.map(chat => (
          <div
            key={chat.id}
            style={{ 
              display: activeChat === chat.id ? 'flex' : 'none',
              height: '100%',
              flexDirection: 'column',
              overflow: 'hidden'
            }}
          >
            <TechnicalSupportChat 
              isModal={false}
              chatId={chat.id}
              onClose={() => closeChat(chat.id)}
              hideHeader={true}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TechnicalSupportChatView;
